export default __webpack_public_path__ + "static/media/provance.33b4c939.jpeg";